import { BASE_URL } from "./config"

export const HUBSPOT_VISITOR_IDENTIFICATION_API_URL = `${BASE_URL}/api/hubspot/visitor-identification/`

export const RESEARCH_AGENT_THREADS_ENDPOINT = "/api/v1/research-agent/threads"
export const RESEARCH_AGENT_STREAM_ENDPOINT = "/api/v1/research-agent/stream"
